/* eslint-disable no-unused-expressions */
import moment from "moment";

export const transformDate = (date, outputFormat) => {
  const possibleInputFormats = [
    "DD.MM.YYYY HH:mm:ss",
    "DD-MM-YYYY HH:mm:ss",
    moment.ISO_8601,
  ];

  return moment.utc(date, possibleInputFormats).local().format(outputFormat);
};

export const getNameAccount = (accountId, mappings) => {
  let res = "";
  mappings?.forEach((elem) => {
    elem.key === accountId ? (res = elem.text) : "";
  });

  return res || "no-name";
};

export const isPositive = (string) => (string?.charAt(0) !== "-" ? "true" : "");

export const creditToDolars = (int) => (int / 100).toFixed(2);

export const deleteHandle = async (
  deleteItem,
  id,
  onButton,
  type,
  onCancel,
) => {
  try {
    await deleteItem(id).unwrap();

    onButton(type);

    if (onCancel) {
      onCancel();
    }
  } catch (error) {
    console.error(error);
  }
};

export const transformYesNoParam = (type) => {
  const paramConfig = {
    No: 0,
    no: 0,
    Yes: 1,
    yes: 1,
  };

  return type ? paramConfig[type] : "";
};
